<template>
  <div class="d-lg-flex">
    <div class="mr-8 responsive-lateral-menu responsive-lateral-menu-mobile-on-top" :class="{ 'is-mobile': $vuetify.display.mobile }" style="width: 250px; flex: 0 0 250px">
      <div class="overflow-y-auto overflow-x-hidden light-scrollbar overscroll-behavior-y-contain pr-2"
           style="position: fixed; top: calc(var(--v-layout-top) + 16px); bottom: 16px; width: 250px">
        <tabs-vertical v-model="openedTabIndex" :direction="$vuetify.display.mobile ? 'horizontal' : 'vertical'">
          <v-tab v-for="tab in projectReportTabs" :key="tab.id" :value="tab.id">
            <v-icon v-if="tab.icon" start>{{ tab.icon }}</v-icon>
            {{ tab.label }}
            <premium-section v-if="tab.premiumFeature" icon :feature="tab.premiumFeature" class="ml-1"></premium-section>
          </v-tab>
        </tabs-vertical>
      </div>
    </div>

    <div v-if="planning.visibleTimeline" class="flex-grow-1 d-flex pr-4" :style="{ 'max-width': openedTabIndex == 'projectsheet' || openedTabIndex == 'risks' ? '1500px' : '900px' }"
         style="min-height: 70vh; overflow: hidden">
      <project-report-windows v-model:opened-tab-index="openedTabIndex" :planning="planning" class="flex-grow-1"
                              @open-element="openElement" @open-project-report="openedTabIndex = $event; scrollToTop()" @update="updateProjectSheet" @reload-planning="reloadPlanning">
      </project-report-windows>
    </div>
  </div>
</template>

<script>
  import clientConfig from '@/client_customs/config';
  import useUiPlanningStore from '@/stores/ui/planning';
  import useEventbusStore from '@/stores/eventbus';
  import ProjectReportWindows from './ProjectReportWindows.vue';

  export default {
    components: {
      ProjectReportWindows,
    },
    props: {
      planning: { type: Object, required: true },
      dynamic: { type: Boolean, default: false },
    },
    emits: ['open-element'],
    data() {
      return {
        openedTabIndex: null,
        customTabs: clientConfig.projectsheet?.customTabs,
        uiPlanningStore: useUiPlanningStore(),
        eventbusStore: useEventbusStore(),
      };
    },
    computed: {
      projectReportTabs() {
        return [
          { id: 'projectsheet', icon: 'far fa-flag', label: this.$t('PROJECT_SHEET.PROJECT_SHEET') },
          ...(this.customTabs || []),
          { id: 'files', icon: 'far fa-paperclip', label: this.$t('PROJECT_SHEET.FILES') },
          { id: 'budget', icon: 'far fa-euro-sign', label: this.$t('PROJECT_SHEET.BUDGET') },
          { id: 'users', icon: 'far fa-user', label: this.$t('PROJECT_SHEET.USERS') },
          { id: 'risks', premiumFeature: 'risks', icon: 'far fa-square-exclamation', label: this.planning.projectsheet?.risks?.title || this.$t('PROJECT_SHEET.RISKS.TITLE') },
        ];
      },
    },
    watch: {
      openedTabIndex() {
        window.sessionStorageWrapper.setItem('option.projectreportTab', this.openedTabIndex);
      },
    },
    created() {
      const configTab = window.sessionStorageWrapper.getItem('option.projectreportTab');
      if (configTab) this.openedTabIndex = configTab;
    },
    methods: {
      reloadPlanning() {
        this.eventbusStore.call({ event: 'update-project' });
      },
      updateProjectSheet(values) {
        _.extend(this.planning.projectsheet, values);
        this.planning.saveAdmin({ projectsheet: this.planning.projectsheet });
      },
      openElement(el) {
        this.uiPlanningStore.scrollToEl({ el, open: this.dynamic });
      },
      scrollToTop() {
        window.scrollTo(0, 0);
      },
    },
  };
</script>
